function LookAheadItem(aEnrolleeId, aStartDate, aEndDate, aData) {
    "use strict";
    this.EnrolleeId = aEnrolleeId;
    this.StartTime = aStartDate;
    this.EndTime = aEndDate;
    this.Data = aData;
}
if (typeof exports !== 'undefined') {
    module.exports = LookAheadItem;
}